import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from './PDFReportCSS';
import { Client, ClientType } from '../../../_models/Client.model';

interface PDFReportNDISQuestionsProps {
  client: Client;
  NDISIncidentOccurred?: boolean;
  NDISPPEUsed?: boolean;
  NDISIncidentDetails?: string;
}

export const PDFReportNDISQuestions: React.FC<PDFReportNDISQuestionsProps> = ({
  client,
  NDISIncidentOccurred,
  NDISPPEUsed,
  NDISIncidentDetails
}) => {
  // Only show for NDIS reports
  if (client.Type !== ClientType.NDIS) {
    return null;
  }

  return (
    <>
      <View style={styles.questionContainer}>
        <Text style={styles.questionText}>
          <Text style={styles.questionLabel}>Did any incidents occur during the cleaning?</Text>
        </Text>
        <Text style={styles.answerText}>
          <Text style={styles.answerLabel}>Answer: </Text>
          <Text style={NDISIncidentOccurred ? styles.answerYes : styles.answerNo}>
            {NDISIncidentOccurred ? 'YES' : 'NO'}
          </Text>
        </Text>
        
        {/* Show incident details if incidents occurred */}
        {NDISIncidentOccurred && NDISIncidentDetails && (
          <View style={styles.incidentDetailsContainer}>
            <Text style={styles.incidentDetailsLabel}>Incident Details:</Text>
            <Text style={styles.incidentDetailsText}>{NDISIncidentDetails}</Text>
          </View>
        )}
      </View>

      <View style={styles.questionContainer}>
        <Text style={styles.questionText}>
          <Text style={styles.questionLabel}>Required PPE was used by the staff member during the session</Text>
        </Text>
        <Text style={styles.answerText}>
          <Text style={styles.answerLabel}>Answer: </Text>
          <Text style={NDISPPEUsed ? styles.answerYes : styles.answerNo}>
            {NDISPPEUsed ? 'YES' : 'NO'}
          </Text>
        </Text>
      </View>
    </>
  );
}; 